<template>
	<page>
		<module enable-flex :tabs="tabs" @tabChange="tabHandle">
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="商品标题">
					<c-input name="product_name"></c-input>
				</m-search-item>
				<m-search-item label="买家昵称">
					<c-input name="nick_name"></c-input>
				</m-search-item>
				<m-search-item label="订单编号">
					<c-input name="order_number"></c-input>
				</m-search-item>
				<m-search-item label="零售订单号">
					<c-input name="retail_order_number"></c-input>
				</m-search-item>
                <m-search-item label="收货信息">
                    <c-input name="receiving_info"></c-input>
                </m-search-item>
				<m-search-item label="下单时间" colspan="2">
					<c-datetime start-name="start_date" end-name="end_date" range></c-datetime>
				</m-search-item>
				<m-search-item label="订单类型" colspan="2">
					<c-checkbox-group name="order_type" :options="orderType"></c-checkbox-group>
				</m-search-item>
			</m-search>
            <m-operate>
                <c-button color="m" hollow @click="syncExport()">导出</c-button>
            </m-operate>
			<c-table ref="table" height="grow">
				<c-table-column
					width="400"
				>
					<template slot="head">
						<span style="margin-left: 15px;">商品信息</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="单价"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="数量"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="总金额"
					width="170"
					align-center
				></c-table-column>
				
				<c-table-column
					label="交易状态"
					width="170"
					align-center
				></c-table-column>
				
				<c-table-column
					label="操作"
					width="170"
					align-center
				></c-table-column>
				
				<template #custom="{data}">
					<div :key="data.id" class="order">
						<div class="order-head flex-between-center">
							<div class="flex-center">
								<!-- <c-checkbox></c-checkbox> -->
								<span class="number">订单号：{{data.order_number}}</span>
								<p class="info"><span class="number">零售订单号：{{data.retail_order_number}}</span>
								<div v-if="data.order_type == 5 || data.order_type == 6" class="tag" style="background: #B232FE">预售</div>
								<div v-if="data.order_type == 7" class="tag" style="background: #0066F1">定制</div>
								<p class="info">下单时间：{{data.create_date}}，买家：{{data.nick_name||data.receiving_name}}</p>
							</div>
						</div>
                        <div class="order-head flex-between-center">
                            <div class="flex-center">
								<span class="number">
									收货信息：{{data.receiving_name}}；{{data.receiving_phone}}；{{data.receiving_address}}
								</span>
                            </div>
                        </div>
						<div class="flex">
							<div class="order-product">
								<div v-for="(sku, i) in data.product_sku_list" :key="i" class="sku flex-center">
									<div class="sku-info flex-center flex-grow">
										<c-file class="sku-image" :src="sku.product_img_url" media></c-file>
										<div class="flex-grow">
                                            <p class="sku-name ellipsis">
                                                <span v-if="sku.product_itemnumber">{{sku.product_itemnumber}} - </span>
                                                {{sku.product_name}}
                                            </p>
											<p class="sku-sku">{{sku.product_sku_spec}}</p>
										</div>
									</div>
									<div class="sku-price">￥{{sku.product_unit_price}}</div>
									<div class="sku-count">{{sku.product_count}}</div>
								</div>
							</div>
							<div class="order-sum flex-column flex-center">
								<span v-if="data.order_type==2 && data.payment_state == 1">
									{{data.product_money}}积分
								</span>
								<span v-if="data.order_type==2 && data.payment_state != 1">
									{{data.payment_money}}积分
								</span>
								<span v-if="data.order_type==2 && data.logistics_money > 0">
									(另运费￥{{parseFloat(data.logistics_money).toFixed(2)}})
								</span>
								<span v-if="data.order_type!=2 && data.payment_state != 3">
									￥{{parseFloat(data.product_money+data.custom_money +data.logistics_money + data.total_fee_money).toFixed(2)}}
								</span>
								<span v-if="data.order_type!=2 && data.payment_state == 3">
									￥{{parseFloat(data.payment_money).toFixed(2)}}
								</span>
								<span v-if="data.order_type!=2 && data.logistics_money > 0" >
									(含运费￥{{parseFloat(data.logistics_money).toFixed(2)}})
								</span>
								<span v-if="data.order_type!=2 && data.total_fee_money > 0" style="color:orangered">
									(含服务费￥{{parseFloat(data.total_fee_money).toFixed(2)}})
								</span>
								<span v-if="data.order_type==7 && data.custom_money > 0" style="color:orangered">
									(含定制费￥{{parseFloat(data.custom_money).toFixed(2)}})
								</span>
							</div>
							<div class="order-state flex-column flex-center">
								<span>{{orderStateName[data.order_state]}}</span>
								<span v-if="data.order_state == 3">({{data.deliver_state}})</span>
								<a @click="navigateTo(`/retail_order_detail/${data.order_number}`)">订单详情</a>
							</div>
							<div class="order-handle flex-column flex-center">
								<c-button v-if="auth('b_retail_order_pay') && data.order_state == 1" color="red" @click="payOrder(data)">支付</c-button>
<!--
								<c-button v-if="auth('b_order_refund_apply') && data.operation_mode == 2 && (data.order_type == 1 || data.order_type == 5 || data.order_type == 6) && data.check_state == 2 && data.refund_flag!=1 && data.return_flag!=1 && (data.order_state==2 || data.order_state==3 || data.order_state==5)" @click="navigateTo(`/after_sale_apply/${data.order_number}`)">申请售后</c-button>
-->
							</div>
						</div>
					</div>
				</template>
			</c-table>
		</module>
		<!--支付方式列表-->
		<c-dialog ref="payTpyeDialog" :title= "'订单【'+this.pay_order_number+'】共需要支付【'+this.pay_money+'】元，请选择支付方式'" width="650" button-name="确认支付方式" @resolve="confirmOrderPay">
			<c-table ref="payTpyeList" :data="payTpyeList" height="400" :paging="false">
				<c-table-column
					type="selector"
					:multiple="false"
				></c-table-column>

				<c-table-column
					label="支付方式"
					width="200"
				>
					<template v-slot="{data}">
						<product-info :image="data.icon" image-size="60" :name="data.name"></product-info>
					</template>
				</c-table-column>

				<c-table-column
					label="备注"
					name="remark"
				></c-table-column>
			</c-table>
		</c-dialog>
		<!--输入验证码弹窗-->
		<c-dialog ref="verifyCodeDialog" title="输入支付验证码" width="600" height="200" @resolve="submitVerifyCode">
			<c-form ref="verifyCodeForm">
				<c-form-item label="手机号" tip="验证码已发送至该手机号">
					<c-input name="phone_number" readonly disabled></c-input>
				</c-form-item>
				<c-form-item label="验证码" tip="请输入收到的验证码" required>
					<c-input name="verify_code" type="number" decimal="0" maxlength="6" required></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
		<!--输入现金支付凭证弹窗-->
		<c-dialog ref="cashVoucherDialog" title="上传现金支付凭证" width="500" height="200" @resolve="submitCashVoucher">
			<c-form ref="cashVoucherForm">
				<c-form-item label="支付凭证" required>
					<c-upload-file name="pay_voucher_url" media type="image" tip="请上传现金支付凭证图片"></c-upload-file>
				</c-form-item>
			</c-form>
		</c-dialog>
		<!--三方支付二维码-->
		<c-dialog ref="qrDialog" :title="'请使用【'+this.pay_channel_name+'】扫码完成支付'" width="410" height="410" :button="false" @close="checkPay(false)">
			<c-file :src="this.qr_code_url" media style="width:400px;height:400px"></c-file>
		</c-dialog>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import productInfo from "@/components/public/product_info.vue";
	import qrcode from 'qrcode';
	export default {
		components: {productInfo},
		props: {
			tab: String
		},
		
		data() {
			return {
                workType:24,
                searchParams:{},
				payTpyeList:[],
				tabsData: [{
					name: '全部代发订单'
				}, {
					name: '待付款',
					param: {
						order_state: [1]
					}
				}, {
					name: '待发货',
					param: {
						order_state: [2]
					}
				}, {
					name: '已发货',
					param: {
						order_state: [3]
					}
				}, {
					name: '交易成功',
					param: {
						order_state: [5]
					}
				}, {
					name: '订单关闭',
					param: {
						order_state: [6]
					}
				}],
				tabsTotal: [],
				currentTab: {},
				orderStateName: {
					1: '待付款',
					2: '待发货',
					3: '待收货',
					5: '交易完结',
					6: '已关闭',
					12: '服务终止'
				},
				pay_order_number:'',        //订单号
				pay_money:0,               //支付金额
				payid:'',                   //支付单号
				pay_channel:'',             //支付渠道
				pay_channel_name:'',        //支付渠道名称
				qr_code_url:''
			}
		},
		
		computed: {
			...mapState(['systemConfig']),
			
			tabs() {
				return Array.from(this.tabsData, (item, index) => {
					return Object.assign({}, item, {
						name: this.tabsTotal[index] > 0 ? `${item.name}(${this.tabsTotal[index]})` : item.name
					});
				});
			},
			
			orderType() {
				return (
					[{
						name: '普通',
						value: 1
					}].concat(this.systemConfig.points_system == 'ON'?[{
						name: '积分',
						value: 2
					}]:[])
					.concat(this.systemConfig.bargain_enabled == 'ON'?[{
						name: '砍价',
						value: 4
					}]:[])
					.concat(this.systemConfig.presell_enabled == 'ON'?[{
						name: '预定全款',
						value: 5
					}]:[])
					.concat(this.systemConfig.presell_enabled == 'ON'?[{
						name: '预定定金',
						value: 6
					}]:[])
					.concat(this.systemConfig.product_custom == 'ON'?[{
						name: '定制',
						value: 7
					}]:[])
				);
			}
		},
		
		mounted() {
			this.updateTotal();
		},
		
		beforeDestroy() {
			this.checkPay(false);
		},

		methods: {
			tabHandle(item) {
				this.currentTab = item;
				this.$refs.search.search();
			},
			
			updateTotal() {
				this.request({
					url: '/retail/order/state/count_list',
					success: data => {
						this.tabsTotal = data;
					}
				});
			},
			
			searchHandle(data) {
				this.$refs.table.load({
					url: '/retail/order/detail_list',
					data: Object.assign(data, this.currentTab.param)
				});
			},
			//订单支付
			payOrder(data){
				this.payTpyeList = [];
				this.pay_order_number = data.order_number;
				this.request({
					url: '/retail/order/get/payid',
					data: {"order_number": this.pay_order_number},
					loading: true,
					success: data => {
						this.$refs.payTpyeDialog.open();
						this.payid = data.payid;
						this.pay_money = data.pay_money;
						if (data.pay_channel_list){
							data.pay_channel_list.forEach(item => {
								if (item && item.list){
									item.list.forEach(item2 => {
										this.payTpyeList.push(item2);
									});
								}
							});
						}
					}
				});//end  request
			},
			//提交支付
			confirmOrderPay(stop){
				stop();
				var rows = this.$refs.payTpyeList.getRow('selected');
				if (!rows.length || rows.length>1) {
					this.$message({
						text: '请选择支付方式'
					});
					return;
				}
				var type = rows[0].data.type;
				this.pay_channel = type;
				//余额或者授信支付，需要输入验证码
				if (type == 'balance' || type == 'credit'){
					this.getPayVerifyCode();
				}else if (type == 'cash'){//现金支付，需要上传凭证
					this.$refs.cashVoucherDialog.open();
					this.$refs.cashVoucherForm.set({
						pay_voucher_url:'',
					});
				}else {//三方支付，生成二维码
					this.otherPay();
				}
			},
			//获取支付短信验证码
			getPayVerifyCode(){
				this.request({
					url: '/retail/order/get/pay/verify/code',
					data: {"order_number": this.pay_order_number},
					loading: true,
					success: (data,obj) => {
						this.$refs.verifyCodeDialog.open();
						this.$refs.verifyCodeForm.set({
							phone_number:data,
						});
					}
				});//end  request
			},
			//支付-提交输入验证码
			submitVerifyCode(stop, next){
				stop();
				this.$refs.verifyCodeForm.submit({
					url: '/retail/order/pay/gateway',
					rule: {
						verify_code: '请输入支付验证码'
					},
					dataFormatter: data => {
						data.order_number = this.pay_order_number;
						data.payid = this.payid;
						data.pay_channel = this.pay_channel;
						return data;
					},
					success:() => {
						next();
						this.$refs.payTpyeDialog.close();
						this.$message({
							type: 'success',
							message: '支付成功'
						});
						//刷新页面
						this.updateTotal();
						this.$refs.table.load({
							url: '/retail/order/detail_list',
							data: Object.assign({}, this.currentTab.param)
						});
					}
				});
			},
			//支付-提交上传支付凭证
			submitCashVoucher(stop, next){
				stop();
				this.$refs.cashVoucherForm.submit({
					url: '/retail/order/pay/gateway',
					rule: {
						pay_voucher_url: '请上传支付凭证'
					},
					dataFormatter: data => {
						data.order_number = this.pay_order_number;
						data.payid = this.payid;
						data.pay_channel = this.pay_channel;
						return data;
					},
					success:() => {
						next();
						this.$refs.payTpyeDialog.close();
						this.$message({
							type: 'success',
							message: '支付成功'
						});
						//刷新页面
						this.updateTotal();
						this.$refs.table.load({
							url: '/retail/order/detail_list',
							data: Object.assign({}, this.currentTab.param)
						});
					}
				});
			},
			//三方支付，形成支付码
			otherPay(){
				this.request({
					url: '/retail/order/pay/gateway',
					data:{
						order_number:this.pay_order_number,
						payid:this.payid,
						pay_channel:this.pay_channel
					},
					success: (data,msg) => {
						if (this.pay_channel == 'wxpay'){
							this.pay_channel_name = '微信';
							// 生成支付二维码
							qrcode.toDataURL(data.qr_code, {
								width: 300,
								height: 300,
								margin: 1.2
							}).then(url => {
								this.qr_code_url = url;
								this.$refs.qrDialog.open();
							});
							this.checkPay();
						}else if (this.pay_channel == 'alipay'){
							this.pay_channel_name = '支付宝';
							// 生成支付二维码
							qrcode.toDataURL(data.qr_code, {
								width: 300,
								height: 300,
								margin: 1.2
							}).then(url => {
								this.qr_code_url = url;
								this.$refs.qrDialog.open();
							});
							this.checkPay();
						}
					}
				});
			},
            /**同步导出数据**/
            syncExport(){
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
			},

			checkPay(state = true) {
				if (!state) {
					this._checkPayTimer && clearTimeout(this._checkPayTimer);
					return;
				}
				this.request({
					url: '/retail/order/pay/check',
					data: {
                        order_number:this.pay_order_number,
                        payid:this.payid
					},
					success: data => {
						if (data == 2) {
                            this.$message({
                                type: 'success',
                                message: '支付成功'
                            });
							this.$refs.payTpyeDialog.close();
							this.$refs.qrDialog.close();
                            //刷新页面
                            this.updateTotal();
                            this.$refs.table.load({
                                url: '/retail/order/detail_list',
                                data: Object.assign({}, this.currentTab.param)
                            });
						} else {
							this._checkPayTimer = setTimeout(this.checkPay, 2000);
						}
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.order {
		border: 1px solid #eee;
		margin: 16px 0;
		
		&-head {
			height: 34px;
			border-bottom: 1px solid #eee;
			padding: 0 8px;
			font-size: 12px;
			background: #F8F8F8;
			
			.number {
				margin-left: 15px;
				color: #333;
			}
			
			.tag {
				border-radius: 2px;
				padding: 0 5px;
				margin-left: 6px;
				line-height: 18px;
				color: #fff;
			}
			
			.info {
				border-left: 1px solid #999;
				padding-left: 8px;
				margin-left: 15px;
				color: #999;
			}
		}
		
		&-product {
			flex-grow: 660;
			flex-basis: 660px;
			
			.sku {
				&:nth-child(n+2) {
					border-top: 1px solid #eee;
				}
				
				&-info {
					flex-grow: 400;
					flex-basis: 400px;
					box-sizing: border-box;
					padding: 10px 0 10px 14px;
				}
				
				&-image {
					width: 80px;
					height: 80px;
					margin-right: 24px;
				}
				
				&-name {
					font-size: 12px;
					color: #666;
				}
				
				&-sku {
					margin-top: 10px;
					font-size: 12px;
				}
				
				&-price,
				&-count {
					flex-grow: 130;
					flex-basis: 130px;
					font-size: 13px;
					text-align: center;
					color: #333;
				}
			}
		}
		
		&-sum,
		&-state,
		&-handle {
			flex-grow: 170;
			flex-basis: 170px;
			box-sizing: border-box;
			border-left: 1px solid #eee;
		}
		
		&-sum {
			line-height: 20px;
			font-size: 12px;
			text-align: center;
			color: #333;
			
			span {
				color: #888;
			}
		}
		
		&-state {
			line-height: 20px;
			font-size: 12px;
			
			a {
				color: #0060EF;
			}
		}
		
		&-handle {
			.c-button {
				width: 6em;
				
				&:nth-child(n+2) {
					margin-top: 8px;
				}
			}
		}
	}
</style>
